export const getToggledNameFilter = (str: string) => {
  if (str.startsWith("-")) return str.slice(1);
  return `-${str}`;
};
